export const SHORT_DISTANCE_FLIGHT = "463"; // Distance in km
export const MEDIUM_DISTANCE_FLIGHT = "3700"; // Distance in km
export const KILOMETERS = "km";
export const NAUTICAL_MILES = "NM";
